import { useAtom, atom } from 'jotai';

// Definimos la interfaz para los datos del grupo
export interface FriendsCupGroupData {
  idGrupo: number;
  nombre: string;
  estado: boolean;
  txtFechaReemplazar?: string;
}

// Definimos los datos iniciales
export const initialFriendsCupGroupData: FriendsCupGroupData = {
  idGrupo: 0,
  nombre: '',
  estado: false,
  txtFechaReemplazar: '',
};

// Creamos el átomo para almacenar los datos
export const friendsCupGroupAtom = atom<FriendsCupGroupData>(
  initialFriendsCupGroupData
);

/**
 * Hook personalizado para manejar los datos de grupos de Copa de Amigos
 * Permite guardar y acceder a la información del grupo, incluyendo el ID
 */
const useFriendsCup = () => {
  const [groupData, setGroupData] = useAtom(friendsCupGroupAtom);

  /**
   * Guarda los datos del grupo en el store
   * @param data Datos del grupo a guardar
   */
  const handleSetGroup = (data: FriendsCupGroupData) => {
    setGroupData(data);
  };

  /**
   * Resetea los datos del grupo a los valores iniciales
   */
  const handleResetGroup = () => {
    setGroupData(initialFriendsCupGroupData);
  };

  return {
    groupData,
    handleSetGroup,
    handleResetGroup,
  };
};

export default useFriendsCup;
